// v-reveal — fade-up on scroll. Adds the `.reveal` class immediately (hidden)
// and `.in` once the element scrolls into view, matching site.css. Honours
// prefers-reduced-motion (the CSS already shows content in that case).
const reveal = {
  mounted(el) {
    el.classList.add('reveal');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    io.observe(el);
    el._revealObserver = io;
  },
  unmounted(el) {
    if (el._revealObserver) el._revealObserver.disconnect();
  },
};

export default reveal;
